// configSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    isLogin: false,
    loginRes: {},
    studentId: null,
    userPhoneNo: null,
    isLoggedIn: false,
    sessionValid: true,
    userStatus: null
};

// Session reducer added on Login 
export const configSlice = createSlice({
    name: "config",
    initialState,
    reducers: {
        loginStart: (state) => {
            state.isLogin = false;
        },
        loginSuccess: (state, action) => {
            state.isLogin = true;
            state.loginRes = action.payload;
        },
        resetConfig: (state) => {
            state.isLogin = false;
            state.loginRes = {};
            state.studentId = null;
            state.isLoggedIn = false;
            state.sessionValid = false;
            state.userStatus = null;
        },
        setStudentId: (state, action) => {
            state.studentId = action.payload; 
        },

        setUserPhoneNo: (state, action) => {
            state.userPhoneNo = action.payload;
        },

        logOut: (state) => {
            state.isLoggedIn = false;
            state.sessionValid = false;
            state.userStatus = null;
            
        },
        setSessionValid: (state, action) => {
            state.sessionValid = action.payload;
            if (!action.payload) {
                state.sessionValid = false;
                state.isLoggedIn = false;
            } else {
                state.sessionValid = true;
                state.isLoggedIn = true;
            }
        },
        setUserStatus: (state, action) => {
            state.userStatus = action.payload;
        },
    
    },
});

export const { loginStart, loginSuccess, setStudentId, resetConfig, setUserPhoneNo, logOut, setSessionValid, setUserStatus } = configSlice.actions;

export default configSlice.reducer;
